import React from 'react';
import { ExternalLink, Landmark, CircleAlert } from 'lucide-react';
import { MinimumInvestment } from './MinimumInvestment.jsx';
import { hasHighMinimum, HIGH_MINIMUM_NOTE } from '../lib/minimum.mjs';
import { dateLabel } from '../lib/format.mjs';

// What an ordinary investor needs before calling the bank: account type,
// where to buy, minimum payment and identification. Each profile is sourced.
export function Prerequisites({ fund }) {
  const p = fund.prerequisites;
  if (!p) return <p>Uvjete kupnje provjerite kod banke distributera i u prospektu fonda.</p>;
  return <div className="prerequisites">
    {p.brokerageAccount && <p className="prereq-callout"><Landmark size={17}/><span><strong>Potreban je brokerski i skrbnički račun.</strong> Ovaj fond ne kupujete običnim zahtjevom za udjele, nego nalogom preko brokerskog računa u banci.</span></p>}
    {hasHighMinimum(fund) && <p className="prereq-callout high-minimum"><CircleAlert size={17}/><span>{HIGH_MINIMUM_NOTE}</span></p>}
    <dl className="facts-list prereq-list">
      <div><dt>Račun</dt><dd>{p.account}</dd></div>
      <div><dt>Minimalna uplata</dt><dd>{fund.minimum ? <MinimumInvestment fund={fund}/> : (fund.minimumNote || 'Provjerite kod banke distributera.')}</dd></div>
      <div><dt>Gdje kupiti</dt><dd><ul className="prereq-channels">{p.channels.map(c => <li key={c}>{c}</li>)}</ul></dd></div>
      <div><dt>Identifikacija</dt><dd>{p.identification}</dd></div>
    </dl>
    {(p.notes?.length > 0 || fund.minimumNote) && <ul className="prereq-notes">{[...(p.notes || []), ...(fund.minimum && fund.minimumNote ? [fund.minimumNote] : [])].map(n => <li key={n}>{n}</li>)}</ul>}
    <p className="source-caption"><a href={p.sourceUrl} target="_blank" rel="noreferrer">{p.sourceLabel}<ExternalLink size={12}/></a> · provjereno {dateLabel(p.checkedAt?.slice(0, 10))} Prije ulaganja pročitajte važeći KID i prospekt fonda.</p>
  </div>;
}
